<h3 mat-dialog-title class="align-center semi-bold">
  {{ 'App.Deliver.Labels.PackageImage' | translate }}
</h3>

<div mat-dialog-content class="pb--xs">
  <div class="row display-flex align-center row-gap--lg justify-content-center">
    @for(image of this.data.packageImages; track image.id){
    <img class="my--sm" width="400px" [src]="image.imageDownLoadUrl" alt="Package Image" />
    }
  </div>
</div>

<div mat-dialog-actions class="row display-column-flex column--12">
  <button mat-button class="hollow-button rounded w-100" (click)="close()">
    {{ 'App.Deliver.Buttons.Close' | translate }}
  </button>
</div>
